<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <ArenaEquipmentForm v-if="equipment" :equipment="equipment" />
      <LoadingPage v-if="!equipment"/>
    </PageRowWrapper>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import ArenaEquipmentForm from '@/components/settings/arena/equipment/ArenaEquipmentForm'
import LoadingPage from '@/components/spinner/LoadingPage'

export default {
  name: 'ArenaEquipmentEdit',
  components: {
    PageTitle,
    PageRowWrapper,
    ArenaEquipmentForm,
    LoadingPage
  },
  computed: {
    ...mapState({
      equipment: state => state.arena.equipmentById
    })
  },
  methods: {
    ...mapActions('arena', ['fetchEquipmentById'])
  },
  mounted () {
    this.fetchEquipmentById(this.$route.params.id)
  }
}
</script>
